export default "__VITE_ASSET__6rCZDDXA__ 1200w";